import script from "./SmartCustomerService.vue?vue&type=script&setup=true&lang=js"
export * from "./SmartCustomerService.vue?vue&type=script&setup=true&lang=js"

import "./SmartCustomerService.vue?vue&type=style&index=0&id=13494048&scoped=true&lang=less"

import exportComponent from "/var/www/tz-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13494048"]])

export default __exports__